var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { hk_jobsdb_com, hk_staging_jobsdb_com, id_jobstreet_com, id_staging_jobstreet_com, my_jobstreet_com, my_staging_jobstreet_com, ph_jobstreet_com, ph_staging_jobstreet_com, seek_co_nz, seek_com_au, sg_jobstreet_com, sg_staging_jobstreet_com, staging_seek_co_nz, staging_seek_com_au, th_jobsdb_com, th_staging_jobsdb_com, } from '../../../config/index.js';
export var stagingConfigs = [
    staging_seek_co_nz,
    staging_seek_com_au,
    hk_staging_jobsdb_com,
    th_staging_jobsdb_com,
    my_staging_jobstreet_com,
    sg_staging_jobstreet_com,
    ph_staging_jobstreet_com,
    id_staging_jobstreet_com,
];
export var prodConfigs = [
    seek_co_nz,
    seek_com_au,
    hk_jobsdb_com,
    th_jobsdb_com,
    my_jobstreet_com,
    sg_jobstreet_com,
    ph_jobstreet_com,
    id_jobstreet_com,
];
export var mappings = (function () {
    var devConfigs = {
        'dev.seek.com.au': staging_seek_com_au,
        'dev.seek.co.nz': staging_seek_co_nz,
        'hk.jobsdb.com.local': hk_staging_jobsdb_com,
        'th.jobsdb.com.local': th_staging_jobsdb_com,
        'my.jobstreet.com.local': my_staging_jobstreet_com,
        'sg.jobstreet.com.local': sg_staging_jobstreet_com,
        'ph.jobstreet.com.local': ph_staging_jobstreet_com,
        'id.jobstreet.com.local': id_staging_jobstreet_com,
        'au.seek.com.local': staging_seek_com_au,
        'nz.seek.com.local': staging_seek_co_nz,
        'my.seek.com.local': my_staging_jobstreet_com,
        'sg.seek.com.local': sg_staging_jobstreet_com,
        'id.seek.com.local': id_staging_jobstreet_com,
        'ph.seek.com.local': ph_staging_jobstreet_com,
        'hk.seek.com.local': hk_staging_jobsdb_com,
        'th.seek.com.local': th_staging_jobsdb_com,
    };
    var result = __assign({}, devConfigs);
    var configs = __spreadArray(__spreadArray([], stagingConfigs, true), prodConfigs, true);
    for (var _i = 0, configs_1 = configs; _i < configs_1.length; _i++) {
        var config = configs_1[_i];
        result[config.clientDomain] = config;
    }
    return result;
})();
export default (function (_a) {
    var _b;
    var host = _a.host;
    var defaultConfig = (host === null || host === void 0 ? void 0 : host.includes('.co.nz'))
        ? staging_seek_co_nz
        : staging_seek_com_au;
    var hostName = host ? host.split(':')[0] : host;
    if (typeof hostName === 'undefined') {
        return defaultConfig;
    }
    return (_b = mappings[hostName]) !== null && _b !== void 0 ? _b : defaultConfig;
});
//# sourceMappingURL=seekjobs.js.map